export default __webpack_public_path__ + "static/media/slider-info-left-light-2.fcd545e5.png";